import { ClinicConfig, PrescriptionAPIConfig } from '../../types';

// Mock clinic config
export let mockClinicConfig: ClinicConfig = {
  clinicName: '',
  taxCode: '',
  phone: '',
  province: '',
  ward: '',
  hamlet: '',
  street: '',
  nationalPrescriptionCode: '',
  nationalPrescriptionAccount: '',
  nationalPrescriptionPassword: '',
  prescriptionCodePrefix: '',
  showNationalPrescription: true,
  clinicInvoiceApiServer: '',
  clinicInvoiceAccount: '',
  clinicInvoicePassword: '',
  clinicInvoiceVATRange: '',
  showClinicInvoice: false,
  pharmacyInvoiceApiServer: '',
  pharmacyInvoiceAccount: '',
  pharmacyInvoicePassword: '',
  pharmacyInvoiceVATRange: '',
  showPharmacyInvoice: false,
};

// Mock prescription API config
export let mockPrescriptionAPIConfig: PrescriptionAPIConfig = {
  serverId: '112.168.0.1',
  code: 'A-20250101-0001',
  timestamp: '2025-11-25T10:20:30Z',
  signature: '-----BEGIN ENCRYPTED PRIVATE KEY-----\nMIIFDjBABgkqhkiG9w0BBQ0wMzAbBgkqhkiG9w0BBQwwDgQI...\n-----END ENCRYPTED PRIVATE KEY-----',
  notes: '',
};

